import { render, staticRenderFns } from "./OptimizationAutomationModal.vue?vue&type=template&id=48b4c517&"
import script from "./OptimizationAutomationModal.vue?vue&type=script&lang=js&"
export * from "./OptimizationAutomationModal.vue?vue&type=script&lang=js&"
import style0 from "./OptimizationAutomationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports